import React, { useState, useEffect } from "react";
import Verifiers from "../../utils/Verifiers";

const DetallesPlanCosechaEntrada = (props) => {
    const p = props.data;
    const i = props.index;
    const spann = props.span ?? 8;
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const [screen, setscreen] = useState({ width: window.innerWidth, height: window.innerHeight });
    var counter = 0;

    useEffect(() => {
        if (counter > 0) return;
        counter++;
        Verifiers.onScreenResize(setscreen)
    }, []);
    const separador = () => { return (<span className="ms-2 me-2 text-900" style={{ color: "#BBBBBB" }}>|</span>) }

    const numberFormat = (number) => {
        try {
            let format = parseFloat(number);
            if (isNaN(format)) return 0;
            return Math.floor(format);
        } catch (error) {
            console.log(`Error ` + error, number);
            return 0;
        }
    }

    return (
        < React.Fragment className='dosis'>
            <tr key={i + 'detalles'} className="m-0">
                <td colSpan={`${spann}`} className="p-2 ">
                    <div className='w-100 text-center text-300 text-s  p-3 bg-light shadow round-xs' style={{ position: 'relative' }}>
                        <div className='row justify-content-evenly m-0 p-0'>

                            <div className='col-lg-12 h5 text-300 mb-2 mt-3'>Resumen de plan de siembra y programa de siembra</div>
                            <div className='m-2 p-1 bg-white text-l text-bold text-danger pointer border round-xxl scale-1 shadow' style={{ position: 'absolute', top: 0, right: 0, width: '100px' }} onClick={props.close}>
                                Cerrar
                            </div>

                            <div className='col-lg-3 text-center round-xs border shadow-sm p-1 bg-white' style={{ width: '32%' }}>
                                <p className="m-0 p-0 text-bold text-s">Plan de siembra</p>
                                <p className="m-0 p-0">
                                    <span className='tex-300 text-xs me-1'> Plantas:</span>
                                    {(p.charolas * 288 * +p.por_germinacion).toFixed(2)}
                                    {separador()}
                                    <span className='tex-300 text-xs me-1'>Charolas:</span>
                                    <span className='text-sucess'>{p.charolas}</span>
                                    {separador()}
                                    <span className='tex-300 text-xs me-1'>GM programa:</span>
                                    <span className='text-sucess'>{p.por_germinacion}%</span>
                                </p>
                            </div>

                            <div className='text-center round-xs border shadow-sm p-1 bg-white' style={{ width: '32%' }}>
                                <p className="m-0 p-0 text-bold">Planificación de siembra por día de la semana</p>
                                <p className="m-0 p-0">
                                    <span className='tex-300 text-xs me-1'> Plantas:</span>
                                    {(p.total_planeado * 288 * +p.por_germinacion).toFixed(2)}
                                    {separador()}
                                    <span className='tex-300 text-xs me-1'>Charolas:</span>
                                    <span className='text-sucess'>{p.total_planeado}</span>
                                    {separador()}
                                    <span className='tex-300 text-xs me-1'>GM DDS:</span>
                                    <span className='text-sucess'>{p.germinacion_real}%</span>
                                </p>
                            </div>

                            <div className='text-center round-xs border shadow-sm p-1 bg-white' style={{ width: '32%' }}>
                                <p className="m-0 p-0 text-bold">Ejecución de siembra por día de la semana</p>
                                <p className="m-0 p-0">
                                    <span className='tex-300 text-xs me-1'> Plantas:</span>
                                    {(p.total_ejecutado * 288 * +p.por_germinacion).toFixed(2)}
                                    {separador()}
                                    <span className='tex-300 text-xs me-1'>Charolas:</span>
                                    <span className='text-sucess'>{p.total_ejecutado}</span>
                                    {separador()}
                                    <span className='tex-300 text-xs me-1'>GM consolidación:</span>
                                    <span className='text-sucess'>{p.germinacion_envio}%</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>

            <tr key={i + 'detalles'} className="m-0 " >
                <td colSpan={`${spann}`} className="p-2 ">
                    <div className='col-lg-12 text-center text-300 text-s mb-5 p-3 bg-light shadow round-xs'>
                        <div className='row justify-content-evenly m-0 p-0'>
                            <div className='col-lg-12 h5 text-300 mb-2 mt-0'>Programa y Ejecución de siembra por día de la semana</div>
                            {
                                dias.map((dia) => {
                                    return (
                                        <div className='p-2 border text-center shadow-sm bg-white' style={{ width: (90 / 6) + '%' }}>
                                            <div className='col-lg-12 text-bold '>{dia.toUpperCase()} <span className="text-xs text-blue3 ms-3">Plan{separador()}Ejecutado</span></div>
                                            <div className='col-lg-12 m-0 p-0 mt-3 text-center text-blue3 text-xs'>Plantas</div>
                                            <div className='col-lg-12 text-center tex-xs mt-0'>
                                                <span className="text-s text-300"> {((p[dia + '_plan'] ?? 0) * 288 * (p.por_germinacion ?? 0)).toFixed(2)}</span>
                                                {separador()}
                                                <span className="text-s text-300"> {((p[dia + '_ejecutado'] ?? 0) * 288 * (p.por_germinacion ?? 0)).toFixed(2)}</span>
                                            </div>
                                            <div className='col-lg-12 m-0 p-0 mt-3 text-center text-blue3 text-xs'>Charolas</div>
                                            <div className='col-lg-12 text-center tex-xs mt-0'>
                                                <span className="text-s text-300"> {p[dia + '_plan']}{separador()}{p[dia + '_ejecutado']}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </td>
            </tr>
        </React.Fragment >
    )
}
export default DetallesPlanCosechaEntrada;